// Capture once: search/filter navigation can replace query parameters inside
// the frame, but the browsing session must remain embedded until it closes.
export function embeddedTripsParent(frameWindow) {
  const params = new URLSearchParams(frameWindow.location.search);
  if (frameWindow.parent === frameWindow || params.get("embed") !== "trips") return null;
  try {
    const parent = new URL(frameWindow.document.referrer);
    return ["http:", "https:"].includes(parent.protocol) ? parent.origin : null;
  } catch { return null; }
}
const parentOrigin = embeddedTripsParent(window);
export const isEmbeddedTrips = Boolean(parentOrigin);
export const notifyTripsParent = (type, payload = {}) => {
  if (parentOrigin) window.parent.postMessage({ type: `sotravel:trips:${type}`, ...payload }, parentOrigin);
};
export const publicTripsUrl = (pathname, search) => {
  const url = new URL(pathname + search, window.location.origin);
  url.searchParams.delete("embed");
  return url.href;
};
